import { useState, useLayoutEffect} from 'react';
import styles from '../styles/body.module.scss'
import btnStyles from '../styles/buttons.module.scss'
import {Box} from '@mui/material';
import Button from '@mui/material/Button';
import axios from '../api/axios';
import useAxiosFunction from '../hooks/useAxiosFunction';
import { useNavigate } from 'react-router-dom';
import { useErrorPopup } from "../components/ui/ErrorPopupContext";
import{BottomNavigation, BottomNavigationAction} from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress';
import CancelIcon from '@mui/icons-material/Cancel';
import Avatar from '@mui/material/Avatar';

export default function SiteRules({siteId, userId, isDrivingToday, setIsDrivingToday, signIn, signOut, askDrivingQue, setAskDrivingQue,
  geolocation, setGeolocation
}) {

  const navigate = useNavigate();
  const goBack = () => {
    navigate("/site/"+siteId)
  }
  const [response, error2,loading, axiosFetch] = useAxiosFunction();
  const { showError } = useErrorPopup();
  const [result, setResult] = useState(false);
  const [progress, setProgress] = useState(false);

  const [submitClicked, setSubmitClicked] = useState(false);

  useLayoutEffect(() => {
    if(result){
      submitAction();
    }
    
  }, [result])


  const nextPage = () =>{
    //if sign in navigate to driving question, else navigate to site page
    //record attendance sign out
    console.log("next page");
    if(submitClicked == false){
      setProgress(true);
      setSubmitClicked(true);
      submit();
    }

  }

  const submit = async e => {
    const bodyObj = JSON.stringify({
      "userId":userId,
      "siteId":siteId,
      "isDriving":isDrivingToday,
      "signIn":signIn,
      "signOut":signOut,
      "signedBy":userId,
      "askDrivingQue":askDrivingQue,
      "geolocation":geolocation
    });

    try {
      await axiosFetch({
        axiosInstance: axios,
        method: 'post',
        url: '/recordAttendance',
        requestConfig: {
          headers: {
            'Content-Type': 'application/json',
          },
          data: bodyObj
        }

      })
    } catch (err) {
      console.log(err);

    }
    setResult(true);
  }

  function submitAction() {
    console.log("RESPONSE: "+response)
    if(response && response.status === 200){
      setProgress(false);
      console.log("reset: ");
      setGeolocation(false);
      navigate("/success");
    }
    else if (response.status === 400) {
      setProgress(false);
      showError("Error 400: Bad Request");
      setTimeout(() => {
        navigate("/");
      }, 3000);
    }
    else {
      console.log(response);
      console.log(error2);

    }
  }


  return (
    <div>
      <Box className={styles.questionH1Top} >
        <h1>Select your action:</h1>
        </Box>

        <Box className={styles.progressBar}>
        {progress && <CircularProgress size="5rem"/>} 
        </Box>
        <Box className={btnStyles.buttonContainer} >
         <Button disabled={progress} className={btnStyles.btn} size="large" variant="contained"  onClick={() => nextPage()}>Sign In</Button>
          <Button disabled={progress}  startIcon={<CancelIcon/>} className={btnStyles.cancelSingleBtn} size="small" variant="contained" onClick={() => goBack()}>Cancel</Button>
          </Box>
          
        
    </div>
  );
}

